export const DOC_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.csv,.tsv,.ppt,.pptx,.odt,.ods,.dwg,.3ds,.ai,.eps,.txt,.rtf,.xml,.json,.html,.htm,.zip,.rar,.7z,.msg,.eml,.pages,.numbers,.keynote';

const IMG_VID_MIME_PREFIXES = ['image/', 'video/'];
const IMG_VID_EXTENSIONS = /\.(jpe?g|png|gif|bmp|webp|tiff?|svg|mp4|mov|avi|wmv|webm|mkv|m4v)$/i;

/**
 * Detect whether a file/media object represents an image or video.
 * Works with: File objects (file.type), API media (collectionName), base64 strings, file extension.
 */
export const isImgOrVid = (file) => {
  if (!file) return false;
  // MIME type check (File objects or objects with a type that looks like MIME)
  const mime = file.type || (file.file && file.file.type) || '';
  if (mime && IMG_VID_MIME_PREFIXES.some((p) => mime.startsWith(p))) return true;
  // Collection name check (API media objects)
  const col = file.collectionName || file.collection_name || file.collection || '';
  if (col.includes('image') || col.includes('task-images') || col.includes('comment-images') || col.includes('signature')) return true;
  if (col.includes('file') || col.includes('task-files') || col.includes('comment-files')) return false;
  // Base64 prefix check
  const data = file.data || '';
  if (typeof data === 'string' && (data.startsWith('data:image/') || data.startsWith('data:video/'))) return true;
  // URL / file name extension check
  const name = file.name || file.fileName || file.fullUrl || (file.file && file.file.name) || '';
  if (typeof name === 'string' && IMG_VID_EXTENSIONS.test(name)) return true;
  // fullUrl check for image URLs
  const url = file.fullUrl || file.url || file.largeUrl || file.thumbUrl || '';
  if (typeof url === 'string' && IMG_VID_EXTENSIONS.test(url)) return true;
  return false;
};

/**
 * Split a mixed array of files into { images, documents }.
 */
export const splitMediaByType = (files) => {
  const images = [];
  const documents = [];
  (files || []).forEach((f) => {
    if (isImgOrVid(f)) {
      images.push(f);
    } else {
      documents.push(f);
    }
  });
  return { images, documents };
};
